import { ChangeDetectionStrategy, Component, computed, inject, input, output, ViewEncapsulation } from "@angular/core";
import { IconModule, PinsModule, PinsStatusModule } from "@jack-sparrow-libraries/ui-kit";
import { SideNavItem } from "@core/layout/components/side-nav/models/side-nav-item.model";
import { SideNavIds } from "@core/layout/components/side-nav/enums/side-nav-ids.enum";
import { IndicateursFacadeService } from "./indicateurs-facade.service";
import { IndicateursApi } from "@core/layout/components/side-nav/components/paiement-menu-item/indicateurs.api";

/**
 * Rendu personnalisé du menu Paiement.
 *
 * Réplique le markup interne de `uikit-menu-item` (@jack-sparrow-libraries/ui-kit v9.2.0)
 * pour pouvoir injecter une pastille de rejets à côté de l'enfant « Mes Impayés »
 * (`PAIEMENT_REJETS`), ce que la lib ne permet pas via `pinsConfig`.
 *
 * TODO GP-2118 : retirer ce composant une fois que la lib expose un slot ou `pinsConfig`
 * pour les enfants. Le markup est aligné sur v9.2.0-bundled.1.
 */
@Component({
	selector: "app-paiement-menu-item",
	templateUrl: "./paiement-menu-item.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [IconModule, PinsModule, PinsStatusModule],
	providers: [IndicateursFacadeService, IndicateursApi],
	standalone: true,
})
export class PaiementMenuItemComponent {
	private readonly indicateursFacade = inject(IndicateursFacadeService);

	readonly $item = input.required<SideNavItem>({ alias: "item" });

	readonly action = output<string>();

	private readonly $rejetsIndicateurs = this.indicateursFacade.$indicateursResourceRef;

	readonly $rejetsCount = computed<number | null>(() => {
		const indicateurs = this.$rejetsIndicateurs.value();
		if (!indicateurs) {
			return null;
		}
		return (
			(indicateurs.nbLotsErreurGP ?? 0) +
			(indicateurs.nbLotsScorErreur ?? 0) +
			(indicateurs.nbLotsSansScor ?? 0) +
			(indicateurs.nbPrescripteursErrones ?? 0) +
			(indicateurs.nbMutuellesInconnues ?? 0) +
			(indicateurs.nbExonerationsInvalidees ?? 0) +
			(indicateurs.nbDemandesDocuments ?? 0) +
			(indicateurs.nbC2sInconnues ?? 0) +
			(indicateurs.nbConventionnementsMutuellesInexistants ?? 0)
		);
	});

	protected readonly SideNavIds = SideNavIds;

	protected onMenu(link: string | null): void {
		if (link) {
			this.action.emit(link);
		}
	}
}
